import React, { useState } from "react";

const pastLeaderboard2025 = [
  { rank: 1, username: "DynamicD", score: 118 },
  { rank: 2, username: "Jeffreywall", score: 114 },
  { rank: 3, username: "James55330", score: 103 },
  { rank: 4, username: "tonyfrank03", score: 101 },
  { rank: 5, username: "AI mock draft", score: 93 },
  { rank: 6, username: "Fubu01082", score: 91 },
  { rank: 7, username: "levitation", score: 88 },
  { rank: 8, username: "Keegan", score: 84 },
  { rank: 9, username: "Jungm012", score: 80 },
  { rank: 10, username: "MADski36", score: 77 },
  { rank: 11, username: "Wyattfiecke", score: 74 },
  { rank: 12, username: "Dtrean", score: 67 },
  { rank: 13, username: "tjhitt64", score: 66 },
  { rank: 14, username: "Mmoore2", score: 63 },
  { rank: 15, username: "Purple People Eaters", score: 62 },
  { rank: 16, username: "Zach M", score: 59 },
  { rank: 17, username: "blackws6ta", score: 57 },
  { rank: 18, username: "Kevinholker", score: 51 },
  { rank: 19, username: "Big Poppa", score: 51 },
  { rank: 20, username: "WrongAnswers", score: 40 },
];

export default function Leaderboard() {
    const [selectedYear, setSelectedYear] = useState("2026");
  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">
  {selectedYear} Leaderboard
</h2>
<div className="mb-4">
  <button
    onClick={() => setSelectedYear("2026")}
    className={`mr-2 px-4 py-2 rounded ${
      selectedYear === "2026" ? "bg-blue-600 text-white" : "bg-gray-200"
    }`}
  >
    2026
  </button>

  <button
    onClick={() => setSelectedYear("2025")}
    className={`px-4 py-2 rounded ${
      selectedYear === "2025" ? "bg-blue-600 text-white" : "bg-gray-200"
    }`}
  >
    2025
  </button>
</div>
      <table className="min-w-full border bg-white">
        <thead>
          <tr>
            <th className="border p-2">Rank</th>
            <th className="border p-2">Username</th>
            <th className="border p-2">Score</th>
          </tr>
        </thead>
        <tbody>
          {(selectedYear === "2025" ? pastLeaderboard2025 : leaderboardData).map((entry) => (
            <tr key={entry.rank}>
              <td className="border p-2 text-center">{entry.rank}</td>
              <td className="border p-2">{entry.username}</td>
              <td className="border p-2 text-center">{entry.score}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}